import { formatDateTime, formatTimeDisplay } from './dateTime';

import { DateRangeOption } from '../../../../../graphql/schema';

type TimePeriodType = {
  label: string;
  value: DateRangeOption;
};

export const timePeriods: TimePeriodType[] = [
  { label: 'Today', value: DateRangeOption.Today },
  { label: '1W', value: DateRangeOption.PastWeek },
  { label: '1M', value: DateRangeOption.PastMonth },
  { label: '3M', value: DateRangeOption.PastThreeMonths },
  { label: '1Y', value: DateRangeOption.PastYear },
  { label: 'All', value: DateRangeOption.AllTime },
];

const timePeriodForValue = (value: DateRangeOption | undefined) => {
  return timePeriods.find(timePeriod => timePeriod.value === value);
};

export const isDateRangeOptionToday = (value: DateRangeOption) => {
  return value === DateRangeOption.Today;
};

export const timePeriodForValueLabel = (value: DateRangeOption) => {
  return timePeriodForValue(value)?.label;
};

export const formattedTimeForDateRangeOption = (dateTime: Date, dateRangeOption: DateRangeOption) => {
  if (isDateRangeOptionToday(dateRangeOption)) {
    return formatTimeDisplay(dateTime);
  }

  return formatDateTime(dateTime);
};
